import React, { Component } from 'react'
import { EndCallProfileTheme } from 'modules/theme'

export class EndCallProfile extends Component {
  render() {
    return (
      <EndCallProfileTheme
        userImg={'images/Profile.png'}
        agentName={'Charlotte Jones'}
        number={'+61 7 70106973'}
        onClickBtnInfo={''}
        btnInfo={'images/info-icon.svg'}
        onClickBtnRejoin={''}
        btnRejoin={'images/reload.svg'}
        textInfo={'Info'}
        textRejoin={'Rejoin'}
        title={'Tag'}
        onChangeSelect={''}
        tagValue={''}
        // optionsTag={this.generateParamsFromArray()}
        optionsTag={''}
        OnClickEvent={''}
        ButtonText={'Done'}
      />
    )
  }
}

export default EndCallProfile


// WEBPACK FOOTER //
// src/dialpad/components/layout/EndCallProfile.js